import { formatDateUtc } from '@zola-helpers/client/dist/es/util/dateUtils';
import type { CoreAccountDetailsValues, LocationAndGuestCountValues } from '../types';

type CoreAccountDetailsRequest = {
  wedding_details: Pick<
    CoreAccountDetailsValues,
    'owner_first_name' | 'owner_last_name' | 'partner_first_name' | 'partner_last_name'
  > & {
    event_date?: Date;
  };
  user?: {
    email: string;
    password: string;
    business_unit_source: CoreAccountDetailsValues['business_unit_source'];
  };
  captchaToken?: string;
  existing_account: boolean;
};

export const formatCoreAccountDetails = (
  values: CoreAccountDetailsValues
): CoreAccountDetailsRequest => {
  const baseRequest = {
    wedding_details: {
      owner_first_name: values.owner_first_name,
      owner_last_name: values.owner_last_name,
      partner_first_name: values.partner_first_name,
      partner_last_name: values.partner_last_name,
      ...(!values.skipDate &&
        values.event_date && {
          event_date: formatDateUtc(values.event_date, 'YYYY-MM-DD[T]hh:mm:ss') as unknown as Date,
        }),
    },
    business_unit_feature: values.business_unit_feature,
    wedding_planning_stage: values.wedding_planning_stage,
  };
  if (values.isExistingAccount) {
    return {
      ...baseRequest,
      existing_account: true,
    };
  }
  return {
    ...baseRequest,
    existing_account: false,
    user: {
      email: values.email,
      password: values.password,
      business_unit_source: values.business_unit_source,
    },
    captchaToken: values.captchaToken,
  };
};

type LocationAndGuestCountRequest = {
  existing_account: boolean;
  business_unit_feature: LocationAndGuestCountValues['business_unit_feature'];
  location_not_listed: boolean | undefined;
  wedding_details: {
    city?: string;
    state_province?: string;
    guest_count?: number;
  };
  venue_details?: LocationAndGuestCountValues['venue_details'];
};

export const formatLocationAndGuestCount = (
  values: LocationAndGuestCountValues,
  existing_account: boolean
): LocationAndGuestCountRequest | undefined => {
  const cityNotListed = values.cityStateValue === 'My city is not listed';
  const skipOrNotFoundLocation = values.skip_location || cityNotListed;
  if (values.skip_location && values.skip_guest_count) return undefined;

  return {
    existing_account,
    business_unit_feature: values.business_unit_feature,
    wedding_details: {
      ...(!skipOrNotFoundLocation && { city: values.city, state_province: values.state_province }),
      ...(!values.skip_guest_count && { guest_count: values.guest_count }),
    },
    location_not_listed: cityNotListed || undefined,
    ...(!values.skip_vendor &&
      !skipOrNotFoundLocation && {
        venue_details: values.venue_details,
      }),
  };
};
